import { Injectable, computed, signal } from '@angular/core';

/**
 * Tracks how many file uploads are in progress across all FileUploadComponent
 * instances on the current page.  Used to disable form save buttons while an
 * upload is still pending, preventing the entity from being saved without the
 * newly-selected image ID.
 *
 * Provided at root so the signal is shared across sibling FileUploadComponents
 * and the parent EntityDetailsComponent without prop-drilling.
 */
@Injectable({ providedIn: 'root' })
export class UploadStateService {
    private activeCount = signal(0);

    /** True while at least one upload is in progress. */
    readonly uploading = computed(() => this.activeCount() > 0);

    /** Call when an upload starts. */
    begin(): void {
        this.activeCount.update((c) => c + 1);
    }

    /** Call when an upload finishes (success or failure). */
    end(): void {
        this.activeCount.update((c) => Math.max(0, c - 1));
    }
}
